import styled from "styled-components";
import { styledByTheme } from "../../../../../themes/architecture/styled-by-theme";
import { GenericSideMenuLinkDefaultBox } from "../../boxes/link/generic-side-menu-link.box";
import { SideMenuLinkIconWrapBase } from "./side-menu-link-icon-wrap-base.box";

const SideMenuLinkIconDefaultBase = styled(SideMenuLinkIconWrapBase)<{active?: boolean}>`
    background-image: url(${({theme}) => theme.images.spriteSheet.toString()});
    background-repeat: no-repeat;
    transition: opacity 0.2s ease, background 0.2s ease;
    background-color: ${({theme, active}) => active ? theme.colors.navItemTextActive : "unset"};
    opacity: ${({active}) => active ? 1 : 0.4};
    ${GenericSideMenuLinkDefaultBox}:hover & {
        opacity: 1;
    }
`;

const SideMenuLinkIconCasino777Base = styled(SideMenuLinkIconDefaultBase)`
    background-color: ${({active}) => active ? "transparent" : "unset"};
    opacity: ${({active}) => active ? 1 : 0.8};
`;

export const SideMenuLinkIconBase = styledByTheme(SideMenuLinkIconDefaultBase)
    .forCasino777(SideMenuLinkIconCasino777Base)
    .apply();
